module.exports = __webpack_public_path__ + "static/media/privacypolicy.76ee3022.htm";